import { render, staticRenderFns } from "./task_moved_to_column.vue?vue&type=template&id=29ad6ae4&scoped=true"
import script from "./task_moved_to_column.vue?vue&type=script&lang=js"
export * from "./task_moved_to_column.vue?vue&type=script&lang=js"
import style0 from "./task_moved_to_column.vue?vue&type=style&index=0&id=29ad6ae4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ad6ae4",
  null
  
)

export default component.exports